// extracted by mini-css-extract-plugin
module.exports = {"tag":"statusItem_tag__2T-Pu","ok":"statusItem_ok__15qut","err":"statusItem_err__1u2YJ"};